import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppIcon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import { supabase } from '../../lib/supabase';
import { deleteOwnAccountViaEdgeFunction } from '../../services/userDeleteAccountClient';

/**
 * حذف حساب العميل (تعطيل منطقي في user_profiles) ثم تسجيل الخروج.
 */
export default function DeleteAccount() {
  const navigate = useNavigate();
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    if (deleting) return;
    const confirmed = window.confirm(
      'هل أنت متأكد من رغبتك في حذف حسابك نهائياً؟ لا يمكن التراجع عن هذا الإجراء.'
    );
    if (!confirmed) return;
    setDeleting(true);
    try {
      await deleteOwnAccountViaEdgeFunction();
      // بعد الحذف، نخرج المستخدم تماماً من الجلسة إلى الصفحة الرئيسية
      try {
        await supabase.auth.signOut();
      } catch (signOutError) {
        console.warn('Sign out after delete failed (customer):', signOutError);
      }
      window.location.href = '/';
    } catch (error) {
      console.error('Delete account error:', error);
      alert(error?.message || 'فشل حذف الحساب، يرجى المحاولة لاحقاً.');
      setDeleting(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 space-y-4">
        <h2
          className="text-xl font-bold text-slate-900 mb-2"
          style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}
        >
          حذف الحساب
        </h2>
        <p className="text-slate-600">
          يمكنك حذف حسابك نهائياً. سيتم إزالة بيانات حسابك وفق سياسات النظام، ولن تتمكن من استعادته لاحقاً.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 pt-2">
          <Button
            variant="outline"
            onClick={() => navigate('/customer-dashboard/account')}
            iconName="ArrowRight"
            iconPosition="right"
          >
            رجوع إلى حسابي
          </Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={deleting}
            iconName={deleting ? 'Loader' : 'Trash2'}
          >
            {deleting ? 'جاري حذف الحساب...' : 'حذف الحساب نهائياً'}
          </Button>
        </div>
      </div>
    </div>
  );
}
